import {apiAction, apiFetch} from "../utils";

/**
 * Adds action creators to bulk tag/untag objects to a duck entity.
 *
 * @param {DuckEntity} duckEntity
 * @return {DuckEntity} updated duckEntity
 */
const taggableDuck = (duckEntity) => {
  const {name, actions, ...entity} = duckEntity;

  const startAction = `schooladmin/${name}/TAG_BEGIN`;
  const successAction = `schooladmin/${name}/TAG_SUCCESS`;
  const failureAction = `schooladmin/${name}/TAG_ERROR`;

  const tag = (ids, tagNames) => apiAction(
    startAction,
    successAction,
    failureAction,

    (state) => apiFetch.post(
      state,
      `${entity.config.apiPath}/tag`,
      {taggable_ids: ids, tags: tagNames}
    ),

    {action: 'add', tagNames}
  );

  const untag = (ids, tagNames) => apiAction(
    startAction,
    successAction,
    failureAction,

    (state) => apiFetch.post(
      state,
      `${entity.config.apiPath}/untag`,
      {taggable_ids: ids, tags: tagNames}
    ),

    {action: 'remove', tagNames}
  );

  return {
    name,
    actions: {
      ...actions,
      tag,
      untag
    },
    ...entity
  };
};

export default taggableDuck;
